import { config } from "@medbillai/ui";

export type Conf = { [K in keyof typeof config]: (typeof config)[K] };

declare module "tamagui" {
  interface TamaguiCustomConfig extends Conf {}
}

export default config;
